import { DropdownField } from '@cian/components';
import * as React from 'react';
import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../common/state';
import { ERoomsTotal } from '../../../../json_query';
import { changeRoomsTotal } from '../../../state/advanced/rooms_total';
import { InlineBlock, Row } from '../markup';

export interface IRoomsTotalProps {
  roomsTotal: ERoomsTotal;
  onRoomsTotalChanged(value: ERoomsTotal): void;
}

export const roomsTotal: React.StatelessComponent<IRoomsTotalProps> = props => (
  <Row title="Комнат в квартире">
    <InlineBlock>
      <DropdownField
        value={props.roomsTotal}
        onValueChange={(value: ERoomsTotal) => props.onRoomsTotalChanged(value)}
        values={[
          { value: ERoomsTotal.Any, label: 'Неважно' },
          { value: ERoomsTotal.One, label: '1' },
          { value: ERoomsTotal.Two, label: '2' },
          { value: ERoomsTotal.Three, label: '3' },
          { value: ERoomsTotal.Four, label: '4' },
          { value: ERoomsTotal.Five, label: '5' },
        ]}
      />
    </InlineBlock>
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    roomsTotal:
      (state.filters.jsonQuery.rooms_count && state.filters.jsonQuery.rooms_count.value[0]) || ERoomsTotal.Any,
  }),
  (dispatch: Dispatch) => ({
    onRoomsTotalChanged: (value: ERoomsTotal) => {
      dispatch(changeRoomsTotal(value));
    },
  }),
)(roomsTotal);
